export enum EMesureTerrainStatus {
    New = 1,
    Pose = 2,
    Recupere = 3,
}